export default __webpack_public_path__ + "static/media/Order.265f9350.jpg";